'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (payload) {
    if (payload && payload.response && payload.response.body && payload.response.body.result && payload.response.body.result.content) {
        return payload.response.body.result.content;
    } else if (payload.message) {
        return payload.message;
    } else {
        return 'Error Making the request';
    }
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getStripeErrorMessageFromResponse.js
// module id = VFQi
// module chunks = 57